import { Component, inject } from '@angular/core';
import { Sidebar } from '../sidebar/sidebar';
import { Header } from '../header/header';
import { RouterModule } from '@angular/router';
import { RiberaLoaderUi } from '@ribera-web/ribera-loader-ui'
import { SpinnerLoadingService } from '@ribera-web/http-loading';

@Component({
  selector: 'lib-shell-admin',
  imports: [RouterModule, Header, Sidebar, RiberaLoaderUi],
  templateUrl: './shell-admin.html',
  styleUrl: './shell-admin.scss',
})
export class ShellAdmin {

  spinner = inject(SpinnerLoadingService);

}
